module.exports = __webpack_public_path__ + "img/10min.5aa7d5ad.webp";